<div
  class="modal-container"
  [ngClass]="data.customContainerClass">
  <div mat-dialog-title>
    <div class="modal__header">
      <div class="modal__title">
        <h1>{{ data.title }}</h1>
      </div>

      <div
        class="mt-2"
        *ngIf="data.body"
        [ngClass]="{ 'w-450': data.limitBodyWidth }">
        <span *ngIf="!data.inlineHtmlBody">{{ data.body }}</span>
        <span
          *ngIf="data.inlineHtmlBody"
          [innerHTML]="data.body"></span>
      </div>

      <button
        class="close-button"
        mat-dialog-close>
        <mat-icon class="material-symbols-rounded">close</mat-icon>
      </button>
    </div>
  </div>
  <mat-dialog-content
    aria-label="Generic modal"
    *ngIf="data.inputs?.length">
    <div class="modal__body pb-7">
      <form [formGroup]="modalForm">
        <div
          class="flex flex-col"
          *ngFor="let input of data.inputs">
          <!--Add new input types here as required-->
          <scope-ui-input
            *ngIf="input.type === 'textarea'"
            class="form-group pb-8 w-full"
            [required]="input.required"
            [inputLabel]="input.label"
            [inputPlaceholder]="input.placeholder"
            [control]="input.control"
            [maximumLength]="input.maxLength"
            (onInputChange)="onInputChange($event, input)"
            [isTextarea]="true"
            [inputClass]="'resize-none'"
            [isDisabled]="input.disabled || isLoading"></scope-ui-input>
          <scope-ui-input
            *ngIf="input.type === 'text'"
            class="form-group pb-8 w-full"
            [required]="input.required"
            [inputLabel]="input.label"
            [inputPlaceholder]="input.placeholder"
            [control]="input.control"
            [maximumLength]="input.maxLength"
            (onInputChange)="onInputChange($event, input)"
            [isDisabled]="input.disabled || isLoading"></scope-ui-input>
          <mat-form-field
            *ngIf="input.type === 'number'"
            class="form-group pb-8 w-full">
            <mat-label>{{ input.label }}</mat-label>
            <input
              class="resize-none"
              type="number"
              max="999"
              min="0"
              matInput
              formControlName="{{ input.name }}"
              placeholder="{{ input.placeholder }}"
              [disabled]="isLoading" />
          </mat-form-field>
          <mat-form-field
            *ngIf="input.type === 'hours'"
            class="form-group pb-8 w-full">
            <mat-label>{{ input.label }}</mat-label>
            <input
              type="text"
              mask="000000"
              matInput
              formControlName="{{ input.name }}"
              placeholder="{{ input.placeholder }}"
              [disabled]="isLoading" />
          </mat-form-field>
          <mat-form-field
            *ngIf="input.type === 'hoursMinutes'"
            class="form-group pb-8 w-full">
            <mat-label>{{ input.label }}</mat-label>
            <input
              type="text"
              mask="h99999:m0"
              [dropSpecialCharacters]="false"
              matInput
              formControlName="{{ input.name }}"
              placeholder="{{ input.placeholder }}"
              [disabled]="isLoading" />
          </mat-form-field>
          <scope-ui-dropdown
            *ngIf="input.type === 'select' && input.options$ !== undefined"
            class="pb-8"
            [controlLabel]="input.label"
            [dropdownOptions]="input.options$ | async"
            [isStandardDropdown]="!input.multiselect"
            [displayFn]="input.optionFn"
            [required]="input.required"
            [disabled]="input.disabled || isLoading"
            [selectedValue]="input.control?.value"
            (onSelectionChange)="onInputChange($event, input)"></scope-ui-dropdown>
          <scope-ui-dropdown
            *ngIf="input.type === 'select' && input.options !== undefined"
            class="pb-8"
            [controlLabel]="input.label"
            [dropdownOptions]="input.options"
            [isStandardDropdown]="!input.multiselect"
            [displayFn]="input.optionFn"
            [required]="input.required"
            [disabled]="input.disabled || isLoading"
            [selectedValue]="input.control?.value"
            (onSelectionChange)="onInputChange($event, input)"></scope-ui-dropdown>
          <scope-ui-autocomplete
            *ngIf="input.type === 'autocomplete' && input.options$ !== undefined"
            [label]="input.label!"
            [options]="input.options$ | async"
            [hasIcon]="true"
            [iconName]="'search'"
            [multiselect]="input.multiselect"
            [optionFn]="input.optionFn"
            [displayFn]="input.optionFn"
            [disabled]="input.disabled || isLoading"
            [initialValue]="input.control?.value"
            (onSelectionChange)="onAutocompleteSelect($event, input)" />
          <scope-ui-autocomplete
            *ngIf="input.type === 'autocomplete' && input.options !== undefined"
            [label]="input.label!"
            [options]="input.options"
            [hasIcon]="true"
            [iconName]="'search'"
            [multiselect]="input.multiselect"
            [optionFn]="input.optionFn"
            [optionDetailsFn]="input.optionDetailsFn"
            [displayFn]="input.optionFn"
            [disabled]="input.disabled || isLoading"
            [initialValue]="input.control?.value"
            (onSelectionChange)="onAutocompleteSelect($event, input)" />
          <description-editor
            *ngIf="input.type === 'description' && !input.control?.value"
            [model]="{}"
            [(visible)]="editDescription"
            [hideNote]="true"
            [disabled]="isLoading"
            (onSaveDescription)="saveDescription($event)">
          </description-editor>
          <description-editor
            *ngIf="input.type === 'description' && input.control?.value"
            [model]="{ description: input.control?.value }"
            [(visible)]="editDescription"
            [hideNote]="true"
            (onSaveDescription)="saveDescription($event)">
          </description-editor>
          <scope-ui-duration
            class="pt-6 block"
            *ngIf="input.type === 'duration'"
            [disabled]="input.disabled"
            [startDate]="modalForm.get('duration').value.startDate"
            [endDate]="modalForm.get('duration').value.endDate"
            [minDate]="input.minDate"
            [maxDate]="input.maxDate"
            (startDateChange)="setStartDate($event)"
            (endDateChange)="setEndDate($event)">
          </scope-ui-duration>
          <mat-slide-toggle
            class="scope-ui-toggle"
            *ngIf="input.type === 'toggle'"
            [disableRipple]="true"
            (change)="onInputChange($event.checked, input)">
            {{ input.label }}
          </mat-slide-toggle>
          <scope-ui-checkbox
            *ngIf="input.type === 'checkbox'"
            [title]="input.label"
            [control]="input.control" />
          <ng-container *ngIf="data.isMemberModal && selections.length">
            <ul class="pt-4 pb-8">
              <li
                *ngFor="let selection of selections"
                class="flex member-row items-center">
                <div class="flex items-center">
                  <ng-container *ngIf="{ showAlt: false } as memberScope">
                    <div
                      *ngIf="memberScope.showAlt"
                      class="member-img d-flex-inline mr-2">
                      <p>{{ selection.firstName.charAt(0) }}</p>
                    </div>
                    <img
                      *ngIf="!memberScope.showAlt"
                      class="member-img d-flex-inline mr-2"
                      src="{{ selection.getPhotoUri(cdnConfig!.userProfileUrl) }}"
                      alt=""
                      (error)="memberScope.showAlt = true" />
                  </ng-container>
                  <div class="flex-col d-flex-inline">
                    <h6 class="product-heading-bold">{{ selection.fullName }}</h6>
                    <span class="text-m">{{ selection.email }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </ng-container>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    class="flex gap-2"
    style="justify-content: flex-end"
    [ngClass]="{ 'no-body': !data.inputs?.length }">
    <button
      mat-button
      *ngIf="data.hasCancelButton && !isLoading"
      [ngClass]="data.flatButton ? 'scope-ui-modal-flat-button' : 'scope-ui-modal-button'"
      (click)="cancel()">
      {{ data.cancelText || 'Cancel' }}
    </button>
    <button
      mat-button
      class="confirm"
      [ngClass]="data.flatButton ? 'scope-ui-modal-flat-button' : 'scope-ui-modal-button'"
      [disabled]="(data.isFormValid && !data.isFormValid(modalForm, selections)) || isLoading"
      [buttonSpinner]="isLoading"
      (click)="confirm()">
      {{ data.confirmText || 'Confirm' }}
    </button>
  </mat-dialog-actions>
</div>
